<template>
  <div class="container">
    Select profile from left to view
  </div>
</template>

<script>

export default {
    name: 'residents'
};
</script>

<style lang="scss" scoped>

</style>
